import { useMemo } from 'react';
import { CallIntelligenceV2, CallIntelTypes, CallIntelUtils } from '@frontend/api-call-intel';
import { useActiveFilters } from './use-active-filters';

export const useFollowUpTabCount = ({
  enabled = true,
}: {
  enabled?: boolean;
} = {}) => {
  const { filters } = useActiveFilters();

  const { data, isLoading } = CallIntelligenceV2.Queries.useGetCallFollowupsStatsQuery({
    request: {
      ...CallIntelUtils.generateFollowupsFilterPayload(filters),
    },
    options: {
      enabled: enabled && !!filters?.locations?.length,
      retry: false,
    },
  });

  const { pendingFollowUpCount, completedFollowUpCount } = useMemo(() => {
    const inProgressStatus = data?.stats?.[CallIntelTypes.TaskStatus.STATUS_IN_PROGRESS] ?? 0;
    const todoStatus = data?.stats?.[CallIntelTypes.TaskStatus.STATUS_TODO] ?? 0;
    const pendingFollowUpCount = inProgressStatus + todoStatus;
    const completedFollowUpCount = data?.stats?.[CallIntelTypes.TaskStatus.STATUS_COMPLETED] ?? 0;

    return {
      pendingFollowUpCount,
      completedFollowUpCount,
    };
  }, [data?.stats]);

  return {
    isLoading,
    pendingFollowUpCount,
    completedFollowUpCount,
  };
};
